import * as React from "react";
import lottie from "lottie-web";

const LottieControl = () => {

  const lottieRef = React.useRef(null);

  React.useEffect(() => {
    var animDuration = 1500;
    const anim = lottie.loadAnimation({
      container: lottieRef.current,
      renderer: "canvas",
      loop: false,
      autoplay: false,
      
      path: 'https://assets7.lottiefiles.com/packages/lf20_k9m4xsuu.json'
    });

    function animatebodymovin(duration) {
      const scrollPosition = window.scrollY;
      const maxFrames = anim.totalFrames;

      const frame = (maxFrames / 100) * (scrollPosition / (duration / 100));

      anim.goToAndStop(frame, true);
    }
    const onScroll = () => {
      console.log("Scrolling");
      animatebodymovin(animDuration);
    };

    document.addEventListener("scroll", onScroll);

    return () => {

      anim.destroy();
      document.removeEventListener("scroll", onScroll);
    };
  }, []);

  return <div id='boxy' style={{ position: "sticky"}} ref={lottieRef}></div>;
};

export default LottieControl;